<template>
  <div class="dashboard">
    <div class="intro">
      <h2>Maak je collectie compleet</h2>
      <p class="light">Deze e-books van Broodje Dunner willen heel graag bij jou op de boekenplank! Klik op de boeken hieronder voor meer informatie.</p>
    </div>

    <UnownedBooks/>

    <ContinueReading/>
  </div>
</template>

<script>
import UnownedBooks from "./books/UnownedBooks.vue";
import ContinueReading from "./books/ContinueReading.vue";

export default {
  name: "Home",
  components: {
    ContinueReading,
    UnownedBooks
  }
};
</script>
